module.exports = __webpack_public_path__ + "img/Травмы коленного сустава.9e038279.jpg";